export const SizeToCarat = {
  round: [
    {
      mm: "0.8",
      weight: "0.0025",
    },
    {
      mm: "1",
      weight: "0.005",
    },
    {
      mm: "1.10",
      weight: "0.0075",
    },
    {
      mm: "1.15",
      weight: "0.0067",
    },
    {
      mm: "1.25",
      weight: "0.01",
    },
    {
      mm: "1.3",
      weight: "0.01",
    },
    {
      mm: "1.5",
      weight: "0.015",
    },
    {
      mm: "1.75",
      weight: "0.02",
    },
    {
      mm: "1.8",
      weight: "0.025",
    },
    {
      mm: "2",
      weight: "0.03",
    },
    {
      mm: "2.25",
      weight: "0.04",
    },
    {
      mm: "2.5",
      weight: "0.06",
    },
    {
      mm: "2.75",
      weight: "0.08",
    },
    {
      mm: "3",
      weight: "0.11",
    },
    {
      mm: "3.25",
      weight: "0.14",
    },
    {
      mm: "3.5",
      weight: "0.17",
    },
    {
      mm: "3.75",
      weight: "0.21",
    },
    {
      mm: "4",
      weight: "0.25",
    },
    {
      mm: "4.25",
      weight: "0.28",
    },
    {
      mm: "4.5",
      weight: "0.36",
    },
    {
      mm: "4.75",
      weight: "0.44",
    },
    {
      mm: "5",
      weight: "0.46",
    },
    {
      mm: "5.25",
      weight: "0.56",
    },
    {
      mm: "5.5",
      weight: "0.66",
    },
    {
      mm: "5.75",
      weight: "0.76",
    },
    {
      mm: "6",
      weight: "0.84",
    },
    {
      mm: "6.25",
      weight: "0.93",
    },
    {
      mm: "6.5",
      weight: "1.03",
    },
    {
      mm: "6.75",
      weight: "1.24",
    },
    {
      mm: "7",
      weight: "1.28",
    },
    {
      mm: "7.25",
      weight: "1.49",
    },
    {
      mm: "7.5",
      weight: "1.67",
    },
    {
      mm: "7.75",
      weight: "1.75",
    },
    {
      mm: "8",
      weight: "2.04",
    },
    {
      mm: "8.25",
      weight: "2.11",
    },
    {
      mm: "8.5",
      weight: "2.43",
    },
    {
      mm: "8.75",
      weight: "2.55",
    },
    {
      mm: "9",
      weight: "2.75",
    },
    {
      mm: "9.25",
      weight: "3.05",
    },
    {
      mm: "9.5",
      weight: "3.35",
    },
    {
      mm: "9.75",
      weight: "3.61",
    },
    {
      mm: "10",
      weight: "3.87",
    },
    {
      mm: "10.25",
      weight: "4.16",
    },
    {
      mm: "10.5",
      weight: "4.41",
    },
    {
      mm: "10.75",
      weight: "4.57",
    },
    {
      mm: "11",
      weight: "4.91",
    },
    {
      mm: "11.25",
      weight: "5.49",
    },
    {
      mm: "11.5",
      weight: "5.85",
    },
    {
      mm: "12",
      weight: "6.84",
    },
    {
      mm: "12.25",
      weight: "7.26",
    },
    {
      mm: "12.5",
      weight: "7.36",
    },
    {
      mm: "12.75",
      weight: "7.52",
    },
    {
      mm: "13",
      weight: "8.51",
    },
    {
      mm: "13.5",
      weight: "9.53",
    },
    {
      mm: "14",
      weight: "10.49",
    },
    {
      mm: "15",
      weight: "12.89",
    },
    {
      mm: "16",
      weight: "16.06",
    },
  ],
  princess: [
    {
      mm: "1.5",
      weight: "0.015",
    },
    {
      mm: "1.75",
      weight: "0.03",
    },
    {
      mm: "2",
      weight: "0.06",
    },
    {
      mm: "2.25",
      weight: "0.08",
    },
    {
      mm: "2.5",
      weight: "0.1",
    },
    {
      mm: "2.75",
      weight: "0.13",
    },
    {
      mm: "3",
      weight: "0.18",
    },
    {
      mm: "3.25",
      weight: "0.26",
    },
    {
      mm: "3.5",
      weight: "0.29",
    },
    {
      mm: "3.75",
      weight: "0.31",
    },
    {
      mm: "4",
      weight: "0.39",
    },
    {
      mm: "4.25",
      weight: "0.44",
    },
    {
      mm: "4.5",
      weight: "0.56",
    },
    {
      mm: "4.75",
      weight: "0.64",
    },
    {
      mm: "5",
      weight: "0.71",
    },
    {
      mm: "5.25",
      weight: "0.75",
    },
    {
      mm: "5.5",
      weight: "0.99",
    },
    {
      mm: "5.75",
      weight: "1.11",
    },
    {
      mm: "6",
      weight: "1.24",
    },
    {
      mm: "6.25",
      weight: "1.39",
    },
    {
      mm: "6.5",
      weight: "1.59",
    },
    {
      mm: "6.75",
      weight: "1.75",
    },
    {
      mm: "7",
      weight: "1.96",
    },
    {
      mm: "7.25",
      weight: "2.01",
    },
    {
      mm: "7.5",
      weight: "2.4",
    },
    {
      mm: "7.75",
      weight: "2.74",
    },
    {
      mm: "8",
      weight: "3.01",
    },
    {
      mm: "8.25",
      weight: "3.24",
    },
    {
      mm: "8.5",
      weight: "3.67",
    },
    {
      mm: "8.75",
      weight: "4.1",
    },
    {
      mm: "9",
      weight: "4.12",
    },
    {
      mm: "9.5",
      weight: "5.09",
    },
    {
      mm: "9.75",
      weight: "5.36",
    },
    {
      mm: "10",
      weight: "5.62",
    },
    {
      mm: "10.25",
      weight: "5.76",
    },
    {
      mm: "10.5",
      weight: "5.99",
    },
    {
      mm: "11",
      weight: "7.44",
    },
    {
      mm: "11.5",
      weight: "9.44",
    },
    {
      mm: "12",
      weight: "9.52",
    },
  ],
  asscher: [
    {
      mm: "4",
      weight: "0.39",
    },
    {
      mm: "4.5",
      weight: "0.56",
    },
    {
      mm: "5",
      weight: "0.71",
    },
    {
      mm: "5.5",
      weight: "0.99",
    },
    {
      mm: "6",
      weight: "1.24",
    },
    {
      mm: "6.5",
      weight: "1.59",
    },
    {
      mm: "7",
      weight: "1.96",
    },
    {
      mm: "7.5",
      weight: "2.4",
    },
    {
      mm: "8",
      weight: "3.01",
    },
    {
      mm: "8.5",
      weight: "3.67",
    },
    {
      mm: "9",
      weight: "4.12",
    },
    {
      mm: "9.5",
      weight: "5.09",
    },
    {
      mm: "10",
      weight: "5.62",
    },
    {
      mm: "11",
      weight: "7.44",
    },
    {
      mm: "12",
      weight: "9.52",
    },
    {
      mm: "13",
      weight: "12.66",
    },
  ],
  cushion: [
    {
      mm: "4",
      weight: "0.25",
    },
    {
      mm: "4.5",
      weight: "0.36",
    },
    {
      mm: "5",
      weight: "0.46",
    },
    {
      mm: "5.25",
      weight: "0.56",
    },
    {
      mm: "5.5",
      weight: "0.66",
    },
    {
      mm: "5.75",
      weight: "0.76",
    },
    {
      mm: "6",
      weight: "0.84",
    },
    {
      mm: "6.25",
      weight: "0.93",
    },
    {
      mm: "6.5",
      weight: "1.03",
    },
    {
      mm: "6.75",
      weight: "1.24",
    },
    {
      mm: "7",
      weight: "1.28",
    },
    {
      mm: "7.5",
      weight: "1.67",
    },
    {
      mm: "8",
      weight: "2.04",
    },
    {
      mm: "8.5",
      weight: "2.43",
    },
    {
      mm: "9",
      weight: "2.75",
    },
    {
      mm: "9.5",
      weight: "3.35",
    },
    {
      mm: "10",
      weight: "3.87",
    },
    {
      mm: "10.5",
      weight: "4.41",
    },
    {
      mm: "11",
      weight: "4.91",
    },
    {
      mm: "11.5",
      weight: "5.85",
    },
    {
      mm: "12",
      weight: "6.84",
    },
    {
      mm: "13",
      weight: "8.51",
    },
    {
      mm: "14",
      weight: "10.49",
    },
    {
      mm: "15",
      weight: "12.89",
    },
  ],
  oval: [
    {
      mm: "4.5 x 3.5",
      weight: "0.21",
    },
    {
      mm: "5 x 3",
      weight: "0.21",
    },
    {
      mm: "5 x 4",
      weight: "0.35",
    },
    {
      mm: "5.5 x 3.5",
      weight: "0.33",
    },
    {
      mm: "6 x 4",
      weight: "0.43",
    },
    {
      mm: "6.5 x 4.5",
      weight: "0.65",
    },
    {
      mm: "6 x 5",
      weight: "0.61",
    },
    {
      mm: "7 x 5",
      weight: "0.76",
    },
    {
      mm: "7.5 x 5.5",
      weight: "0.98",
    },
    {
      mm: "8 x 6",
      weight: "1.21",
    },
    {
      mm: "8.5 x 6.5",
      weight: "1.46",
    },
    {
      mm: "9 x 6",
      weight: "1.41",
    },
    {
      mm: "9 x 7",
      weight: "1.86",
    },
    {
      mm: "10 x 8",
      weight: "2.54",
    },
    {
      mm: "10.5 x 8.5",
      weight: "2.88",
    },
    {
      mm: "11 x 9",
      weight: "3.85",
    },
    {
      mm: "12 x 8",
      weight: "2.99",
    },
    {
      mm: "12 x 10",
      weight: "5.05",
    },
    {
      mm: "14 x 10",
      weight: "5.81",
    },
    {
      mm: "13 x 11",
      weight: "6.05",
    },
    {
      mm: "14 x 12",
      weight: "8.21",
    },
    {
      mm: "15 x 12",
      weight: "8.76",
    },
    {
      mm: "16 x 12",
      weight: "9.32",
    },
    {
      mm: "16 x 14",
      weight: "11.88",
    },
    {
      mm: "18 x 13",
      weight: "12.86",
    },
    {
      mm: "20 x 15",
      weight: "14.96",
    },
  ],
  radiant: [
    {
      mm: "4.5 x 3.5",
      weight: "0.34",
    },
    {
      mm: "5 x 3",
      weight: "0.31",
    },
    {
      mm: "6 x 3",
      weight: "0.41",
    },
    {
      mm: "6 x 4",
      weight: "0.60",
    },
    {
      mm: "6.5 x 4.5",
      weight: "0.83",
    },
    {
      mm: "7 x 5",
      weight: "1.14",
    },
    {
      mm: "7.25 x 5.25",
      weight: "1.24",
    },
    {
      mm: "7.5 x 5.5",
      weight: "1.47",
    },
    {
      mm: "8 x 6",
      weight: "1.74",
    },
    {
      mm: "8.5 x 6.5",
      weight: "2.25",
    },
    {
      mm: "9 x 7",
      weight: "2.62",
    },
    {
      mm: "9.5 x 7.5",
      weight: "3.18",
    },
    {
      mm: "10 x 7",
      weight: "3.31",
    },
    {
      mm: "10 x 8",
      weight: "3.49",
    },
    {
      mm: "11 x 9",
      weight: "5.05",
    },
    {
      mm: "11.5 x 10",
      weight: "6.45",
    },
    {
      mm: "12 x 9",
      weight: "6.06",
    },
    {
      mm: "12 x 10",
      weight: "6.79",
    },
    {
      mm: "13 x 9",
      weight: "6.54",
    },
    {
      mm: "13 x 11",
      weight: "9.33",
    },
    {
      mm: "13.5 x 11.5",
      weight: "10.19",
    },
    {
      mm: "14 x 10",
      weight: "8.47",
    },
    {
      mm: "14 x 12",
      weight: "12.14",
    },
    {
      mm: "15 x 11",
      weight: "11.48",
    },
    {
      mm: "16 x 12",
      weight: "14.22",
    },
  ],
  pear: [
    {
      mm: "3 x 2",
      weight: "0.13",
    },
    {
      mm: "4 x 2.5",
      weight: "0.18",
    },
    {
      mm: "4 x 3",
      weight: "0.21",
    },
    {
      mm: "5 x 3",
      weight: "0.25",
    },
    {
      mm: "5 x 4",
      weight: "0.35",
    },
    {
      mm: "6 x 4",
      weight: "0.39",
    },
    {
      mm: "6.5 x 4.5",
      weight: "0.57",
    },
    {
      mm: "7 x 5",
      weight: "0.71",
    },
    {
      mm: "8 x 5",
      weight: "0.81",
    },
    {
      mm: "8.5 x 5.5",
      weight: "1.08",
    },
    {
      mm: "8 x 6",
      weight: "1.25",
    },
    {
      mm: "9 x 6",
      weight: "1.33",
    },
    {
      mm: "9 x 7",
      weight: "1.75",
    },
    {
      mm: "10 x 6",
      weight: "1.71",
    },
    {
      mm: "10 x 7",
      weight: "1.8",
    },
    {
      mm: "10 x 8",
      weight: "2.46",
    },
    {
      mm: "11 x 7.50",
      weight: "2.61",
    },
    {
      mm: "11 x 8",
      weight: "3",
    },
    {
      mm: "12 x 7",
      weight: "3.12",
    },
    {
      mm: "12 x 8",
      weight: "3",
    },
    {
      mm: "12 x 9",
      weight: "3.44",
    },
    {
      mm: "13 x 8",
      weight: "2.98",
    },
    {
      mm: "14 x 8",
      weight: "3.47",
    },
    {
      mm: "13 x 9",
      weight: "4.11",
    },
    {
      mm: "14 x 9",
      weight: "4.25",
    },
    {
      mm: "15 x 9",
      weight: "5.06",
    },
    {
      mm: "14 x 10",
      weight: "5.41",
    },
    {
      mm: "13 x 11",
      weight: "5.65",
    },
    {
      mm: "15 x 10",
      weight: "5.75",
    },
    {
      mm: "15 x 11",
      weight: "7.36",
    },
    {
      mm: "16 x 9",
      weight: "5.86",
    },
    {
      mm: "16 x 10",
      weight: "6.27",
    },
    {
      mm: "16 x 12",
      weight: "8.99",
    },
    {
      mm: "17 x 10",
      weight: "6.46",
    },
    {
      mm: "18 x 11",
      weight: "8.14",
    },
    {
      mm: "18 x 12",
      weight: "9.35",
    },
    {
      mm: "18 x 13",
      weight: "10.21",
    },
  ],
  heart: [
    {
      mm: "3.5",
      weight: "0.18",
    },
    {
      mm: "4",
      weight: "0.25",
    },
    {
      mm: "4.25",
      weight: "0.28",
    },
    {
      mm: "4.5",
      weight: "0.34",
    },
    {
      mm: "4.75",
      weight: "0.38",
    },
    {
      mm: "5",
      weight: "0.44",
    },
    {
      mm: "5.5",
      weight: "0.61",
    },
    {
      mm: "6",
      weight: "0.74",
    },
    {
      mm: "6.25",
      weight: "0.83",
    },
    {
      mm: "6.5",
      weight: "0.93",
    },
    {
      mm: "7",
      weight: "1.13",
    },
    {
      mm: "7.5",
      weight: "1.59",
    },
    {
      mm: "8",
      weight: "1.71",
    },
    {
      mm: "9",
      weight: "2.41",
    },
    {
      mm: "9.5",
      weight: "2.9",
    },
    {
      mm: "10",
      weight: "3.16",
    },
    {
      mm: "11",
      weight: "4.41",
    },
    {
      mm: "12",
      weight: "5.66",
    },
    {
      mm: "13",
      weight: "7.88",
    },
    {
      mm: "14",
      weight: "9.38",
    },
    {
      mm: "15",
      weight: "10.79",
    },
    {
      mm: "16",
      weight: "13.27",
    },
    {
      mm: "18",
      weight: "15.33",
    },
  ],
  marquise: [
    {
      mm: "3 x 1.5",
      weight: "0.025",
    },
    {
      mm: "3.5 x 1.75",
      weight: "0.065",
    },
    {
      mm: "3.5 x 2",
      weight: "0.07",
    },
    {
      mm: "3.75 x 1.75",
      weight: "0.11",
    },
    {
      mm: "4 x 2",
      weight: "0.1",
    },
    {
      mm: "4.25 x 2.25",
      weight: "0.12",
    },
    {
      mm: "5 x 2.5",
      weight: "0.14",
    },
    {
      mm: "5 x 3",
      weight: "0.2",
    },
    {
      mm: "5.5 x 2.75",
      weight: "0.16",
    },
    {
      mm: "5.5 x 3",
      weight: "0.18",
    },
    {
      mm: "6 x 3",
      weight: "0.25",
    },
    {
      mm: "6.5 x 3",
      weight: "0.23",
    },
    {
      mm: "7 x 3",
      weight: "0.3",
    },
    {
      mm: "7 x 3.5",
      weight: "0.35",
    },
    {
      mm: "7 x 4",
      weight: "0.34",
    },
    {
      mm: "7.5 x 3.5",
      weight: "0.33",
    },
    {
      mm: "8 x 4",
      weight: "0.47",
    },
    {
      mm: "9 x 4.5",
      weight: "0.71",
    },
    {
      mm: "9 x 5",
      weight: "0.76",
    },
    {
      mm: "9.5 x 5",
      weight: "0.85",
    },
    {
      mm: "10 x 5",
      weight: "0.95",
    },
    {
      mm: "11 x 5.5",
      weight: "1.25",
    },
    {
      mm: "11.5 x 6",
      weight: "1.33",
    },
    {
      mm: "12 x 6",
      weight: "1.62",
    },
    {
      mm: "12 x 6.5",
      weight: "1.71",
    },
    {
      mm: "13 x 6.5",
      weight: "2.11",
    },
    {
      mm: "14 x 7",
      weight: "2.48",
    },
    {
      mm: "15 x 7.5",
      weight: "3.09",
    },
    {
      mm: "14 x 8",
      weight: "3",
    },
    {
      mm: "15 x 7",
      weight: "3.12",
    },
    {
      mm: "15 x 8",
      weight: "3.44",
    },
    {
      mm: "16 x 8",
      weight: "3.86",
    },
    {
      mm: "17 x 8.5",
      weight: "4.88",
    },
    {
      mm: "17.5 x 10",
      weight: "5.5",
    },
    {
      mm: "20 x 8",
      weight: "7.08",
    },
    {
      mm: "20 x 10",
      weight: "7.94",
    },
    {
      mm: "20 x 11",
      weight: "9.5",
    },
  ],
  triangle: [
    {
      mm: "2.5",
      weight: "0.08",
    },
    {
      mm: "3",
      weight: "0.12",
    },
    {
      mm: "3.5",
      weight: "0.18",
    },
    {
      mm: "4",
      weight: "0.25",
    },
    {
      mm: "4.25",
      weight: "0.32",
    },
    {
      mm: "4.5",
      weight: "0.37",
    },
    {
      mm: "4.75",
      weight: "0.42",
    },
    {
      mm: "5",
      weight: "0.45",
    },
    {
      mm: "5.25",
      weight: "0.53",
    },
    {
      mm: "5.5",
      weight: "0.66",
    },
    {
      mm: "5.75",
      weight: "0.71",
    },
    {
      mm: "6",
      weight: "0.76",
    },
    {
      mm: "6.25",
      weight: "0.86",
    },
    {
      mm: "6.5",
      weight: "0.94",
    },
    {
      mm: "6.75",
      weight: "1.02",
    },
    {
      mm: "7",
      weight: "1.11",
    },
    {
      mm: "7.25",
      weight: "1.32",
    },
    {
      mm: "7.5",
      weight: "1.45",
    },
    {
      mm: "7.75",
      weight: "1.69",
    },
    {
      mm: "8",
      weight: "1.79",
    },
    {
      mm: "8.25",
      weight: "1.86",
    },
    {
      mm: "9",
      weight: "2.15",
    },
    {
      mm: "9.25",
      weight: "2.54",
    },
    {
      mm: "9.75",
      weight: "3.25",
    },
    {
      mm: "10",
      weight: "3.52",
    },
    {
      mm: "11",
      weight: "4.74",
    },
    {
      mm: "12",
      weight: "6.03",
    },
    {
      mm: "13",
      weight: "8.12",
    },
    {
      mm: "14",
      weight: "9.83",
    },
  ],
  trillion: [
    {
      mm: "3",
      weight: "0.12",
    },
    {
      mm: "3.5",
      weight: "0.16",
    },
    {
      mm: "3.75",
      weight: "0.19",
    },
    {
      mm: "4",
      weight: "0.23",
    },
    {
      mm: "4.25",
      weight: "0.27",
    },
    {
      mm: "4.5",
      weight: "0.31",
    },
    {
      mm: "4.75",
      weight: "0.37",
    },
    {
      mm: "5",
      weight: "0.42",
    },
    {
      mm: "5.25",
      weight: "0.49",
    },
    {
      mm: "5.5",
      weight: "0.55",
    },
    {
      mm: "5.75",
      weight: "0.64",
    },
    {
      mm: "6",
      weight: "0.7",
    },
    {
      mm: "6.25",
      weight: "0.75",
    },
    {
      mm: "6.5",
      weight: "0.91",
    },
    {
      mm: "6.75",
      weight: "0.98",
    },
    {
      mm: "7",
      weight: "1.1",
    },
    {
      mm: "7.5",
      weight: "1.21",
    },
    {
      mm: "8",
      weight: "1.75",
    },
    {
      mm: "9",
      weight: "2.35",
    },
    {
      mm: "11",
      weight: "3.66",
    },
    {
      mm: "12",
      weight: "4.9",
    },
    {
      mm: "13",
      weight: "6.42",
    },
    {
      mm: "15",
      weight: "9",
    },
  ],
  baguette: [
    {
      mm: "2 x 1",
      weight: "0.02",
    },
    {
      mm: "2 x 1.5",
      weight: "0.04",
    },
    {
      mm: "2 x 1.75",
      weight: "0.04",
    },
    {
      mm: "2.25 x 1.75",
      weight: "0.04",
    },
    {
      mm: "2.25 x 2",
      weight: "0.045",
    },
    {
      mm: "2.5 x 1",
      weight: "0.045",
    },
    {
      mm: "2.5 x 1.25",
      weight: "0.047",
    },
    {
      mm: "2.5 x 1.5",
      weight: "0.05",
    },
    {
      mm: "2.5 x 1.75",
      weight: "0.055",
    },
    {
      mm: "2.5 x 2",
      weight: "0.055",
    },
    {
      mm: "2.75 x 1.5",
      weight: "0.055",
    },
    {
      mm: "2.75 x 1.75",
      weight: "0.06",
    },
    {
      mm: "2.75 x 2",
      weight: "0.06",
    },
    {
      mm: "2.75 x 2.5",
      weight: "0.065",
    },
    {
      mm: "3 x 1",
      weight: "0.05",
    },
    {
      mm: "3 x 1.25",
      weight: "0.055",
    },
    {
      mm: "3 x 1.5",
      weight: "0.06",
    },
    {
      mm: "3 x 1.75",
      weight: "0.08",
    },
    {
      mm: "3 x 2",
      weight: "0.1",
    },
    {
      mm: "3 x 2.5",
      weight: "0.13",
    },
    {
      mm: "3.25 x 1.25",
      weight: "0.06",
    },
    {
      mm: "3.25 x 1.5",
      weight: "0.065",
    },
    {
      mm: "3.25 x 1.75",
      weight: "0.08",
    },
    {
      mm: "3.25 x 2.5",
      weight: "0.14",
    },
    {
      mm: "3.5 x 1",
      weight: "0.065",
    },
    {
      mm: "3.5 x 1.25",
      weight: "0.07",
    },
    {
      mm: "3.5 x 1.5",
      weight: "0.07",
    },
    {
      mm: "3.5 x 1.75",
      weight: "0.08",
    },
    {
      mm: "3.5 x 2",
      weight: "0.13",
    },
    {
      mm: "3.5 x 2.5",
      weight: "0.15",
    },
    {
      mm: "3.5 x 3",
      weight: "0.15",
    },
    {
      mm: "3.75 x 1.5",
      weight: "0.14",
    },
    {
      mm: "3.75 x 2",
      weight: "0.145",
    },
    {
      mm: "4 x 1.25",
      weight: "0.075",
    },
    {
      mm: "4 x 1.5",
      weight: "0.08",
    },
    {
      mm: "4 x 1.75",
      weight: "0.11",
    },
    {
      mm: "4 x 2",
      weight: "0.14",
    },
    {
      mm: "4 x 3",
      weight: "0.2",
    },
    {
      mm: "4.5 x 1.5",
      weight: "0.1",
    },
    {
      mm: "4.5 x 1.75",
      weight: "0.14",
    },
    {
      mm: "4.5 x 2",
      weight: "0.17",
    },
    {
      mm: "4.5 x 2.5",
      weight: "0.2",
    },
    {
      mm: "4.5 x 3",
      weight: "0.285",
    },
    {
      mm: "4.5 x 3.5",
      weight: "0.3",
    },
    {
      mm: "4.75 x 1.5",
      weight: "0.27",
    },
    {
      mm: "4.75 x 2",
      weight: "0.28",
    },
    {
      mm: "5 x 1.5",
      weight: "0.14",
    },
    {
      mm: "5 x 1.75",
      weight: "0.15",
    },
    {
      mm: "5 x 2",
      weight: "0.19",
    },
    {
      mm: "5 x 2.5",
      weight: "0.24",
    },
    {
      mm: "5 x 3",
      weight: "0.3",
    },
    {
      mm: "5 x 3.5",
      weight: "0.33",
    },
    {
      mm: "5 x 4",
      weight: "0.4",
    },
    {
      mm: "5.5 x 1.75",
      weight: "0.16",
    },
    {
      mm: "5.5 x 2",
      weight: "0.18",
    },
    {
      mm: "5.5 x 2.5",
      weight: "0.23",
    },
    {
      mm: "5.5 x 3",
      weight: "0.3",
    },
    {
      mm: "5.5 x 3.5",
      weight: "0.33",
    },
    {
      mm: "6 x 1.75",
      weight: "0.28",
    },
    {
      mm: "6 x 2",
      weight: "0.3",
    },
    {
      mm: "6 x 2.5",
      weight: "0.33",
    },
    {
      mm: "6 x 3",
      weight: "0.4",
    },
  ],
  taperedBaguette: [
    {
      mm: "2 x 1.5 x 1",
      weight: "0.025",
    },
    {
      mm: "2.5 x 1.5 x 1",
      weight: "0.035",
    },
    {
      mm: "2.5 x 1.75 x 1",
      weight: "0.04",
    },
    {
      mm: "3 x 1.5 x 1",
      weight: "0.05",
    },
    {
      mm: "3 x 1.75 x 1.25",
      weight: "0.055",
    },
    {
      mm: "3 x 1.75 x 1.3",
      weight: "0.055",
    },
    {
      mm: "3 x 1.75 x 1.5",
      weight: "0.055",
    },
    {
      mm: "3 x 2 x 1",
      weight: "0.06",
    },
    {
      mm: "3 x 2 x 1.25",
      weight: "0.065",
    },
    {
      mm: "3 x 2 x 1.5",
      weight: "0.07",
    },
    {
      mm: "3 x 2 x 1.75",
      weight: "0.075",
    },
    {
      mm: "3 x 2.5 x 2",
      weight: "0.08",
    },
    {
      mm: "3.25 x 1.75 x 1",
      weight: "0.07",
    },
    {
      mm: "3.25 x 1.75 x 1.25",
      weight: "0.05",
    },
    {
      mm: "3.5 x 1.25 x 1",
      weight: "0.04",
    },
    {
      mm: "3.5 x 1.5 x 1",
      weight: "0.05",
    },
    {
      mm: "3.5 x 1.5 x 1.25",
      weight: "0.055",
    },
    {
      mm: "3.5 x 1.7 x 1.3",
      weight: "0.055",
    },
    {
      mm: "3.5 x 1.75 x 1",
      weight: "0.06",
    },
    {
      mm: "3.5 x 1.75 x 1.25",
      weight: "0.07",
    },
    {
      mm: "3.5 x 1.75 x 1.3",
      weight: "0.065",
    },
    {
      mm: "3.5 x 2 x 1.25",
      weight: "0.08",
    },
    {
      mm: "3.5 x 2 x 1.5",
      weight: "0.09",
    },
    {
      mm: "3.5 x 2.5 x 2",
      weight: "0.09",
    },
    {
      mm: "3.75 x 2 x 1.25",
      weight: "0.08",
    },
    {
      mm: "4 x 1.5 x 1",
      weight: "0.07",
    },
    {
      mm: "4 x 1.5 x 1.2",
      weight: "0.08",
    },
    {
      mm: "4 x 1.75 x 1.25",
      weight: "0.08",
    },
    {
      mm: "4 x 2 x 1.5",
      weight: "0.1",
    },
    {
      mm: "4 x 2.5 x 1.5",
      weight: "0.12",
    },
    {
      mm: "4 x 2.5 x 2",
      weight: "0.21",
    },
    {
      mm: "4 x 3 x 2",
      weight: "0.21",
    },
    {
      mm: "4.25 x 2 x 1.25",
      weight: "0.11",
    },
    {
      mm: "4.25 x 2 x 1.5",
      weight: "0.13",
    },
    {
      mm: "4.25 x 2.5 x 1.25",
      weight: "0.13",
    },
    {
      mm: "4.25 x 2.5 x 1.5",
      weight: "0.135",
    },
    {
      mm: "4.5 x 1.75 x 1.25",
      weight: "0.15",
    },
    {
      mm: "4.5 x 2 x 1.5",
      weight: "0.12",
    },
    {
      mm: "4.5 x 2.3 x 1.8",
      weight: "0.16",
    },
    {
      mm: "4.5 x 2.5 x 2",
      weight: "0.15",
    },
    {
      mm: "4.5 x 2.75 x 1.75",
      weight: "0.15",
    },
    {
      mm: "4.5 x 3 x 2",
      weight: "0.16",
    },
    {
      mm: "4.5 x 3 x 2.5",
      weight: "0.16",
    },
    {
      mm: "4.75 x 2.5 x 1.5",
      weight: "0.15",
    },
    {
      mm: "4.75 x 3 x 2",
      weight: "0.18",
    },
    {
      mm: "5 x 2 x 1",
      weight: "0.14",
    },
    {
      mm: "5 x 2 x 1.25",
      weight: "0.15",
    },
    {
      mm: "5 x 2 x 1.5",
      weight: "0.15",
    },
    {
      mm: "5 x 2.3 x 1.8",
      weight: "0.16",
    },
    {
      mm: "5 x 2.5 x 1.5",
      weight: "0.2",
    },
    {
      mm: "5 x 2.5 x 2",
      weight: "0.21",
    },
    {
      mm: "5 x 2.75 x 2",
      weight: "0.21",
    },
    {
      mm: "5 x 3 x 2",
      weight: "0.25",
    },
    {
      mm: "5 x 3.5 x 2",
      weight: "0.26",
    },
    {
      mm: "5 x 4 x 3.5",
      weight: "0.28",
    },
    {
      mm: "5.5 x 2 x 1.5",
      weight: "0.18",
    },
    {
      mm: "5.5 x 2.5 x 1.75",
      weight: "0.23",
    },
    {
      mm: "5.5 x 2.5 x 2",
      weight: "0.23",
    },
    {
      mm: "5.5 x 3 x 2",
      weight: "0.26",
    },
    {
      mm: "5.5 x 3 x 2.25",
      weight: "0.26",
    },
    {
      mm: "5.5 x 4 x 2.5",
      weight: "0.28",
    },
    {
      mm: "6 x 2 x 1.5",
      weight: "0.3",
    },
    {
      mm: "6 x 2.5 x 1.5",
      weight: "0.3",
    },
    {
      mm: "6 x 3 x 2",
      weight: "0.3",
    },
    {
      mm: "6.5 x 2.5 x 2",
      weight: "0.3",
    },
    {
      mm: "6.5 x 3 x 2",
      weight: "0.32",
    },
  ],
  emerald: [
    {
      mm: "3 x 2",
      weight: "0.1",
    },
    {
      mm: "3.5 x 2",
      weight: "0.12",
    },
    {
      mm: "4 x 2",
      weight: "0.15",
    },
    {
      mm: "4 x 3",
      weight: "0.2",
    },
    {
      mm: "5 x 3",
      weight: "0.29",
    },
    {
      mm: "5.5 x 3.5",
      weight: "0.46",
    },
    {
      mm: "5.5 x 4",
      weight: "0.48",
    },
    {
      mm: "6 x 4",
      weight: "0.66",
    },
    {
      mm: "6.5 x 4.5",
      weight: "0.88",
    },
    {
      mm: "7 x 5",
      weight: "1.06",
    },
    {
      mm: "7.25 x 5.25",
      weight: "1.24",
    },
    {
      mm: "7.5 x 5.5",
      weight: "1.45",
    },
    {
      mm: "8 x 6",
      weight: "1.74",
    },
    {
      mm: "8.5 x 6.5",
      weight: "2.17",
    },
    {
      mm: "9 x 7",
      weight: "2.62",
    },
    {
      mm: "9.5 x 7.5",
      weight: "3.21",
    },
    {
      mm: "10 x 7",
      weight: "3.01",
    },
    {
      mm: "10 x 8",
      weight: "3.79",
    },
    {
      mm: "11 x 9",
      weight: "5.21",
    },
    {
      mm: "12 x 8",
      weight: "5.34",
    },
    {
      mm: "12 x 10",
      weight: "6",
    },
    {
      mm: "13 x 9",
      weight: "6.38",
    },
    {
      mm: "14 x 8",
      weight: "6.25",
    },
    {
      mm: "14 x 10",
      weight: "8.48",
    },
    {
      mm: "13 x 11",
      weight: "9.13",
    },
    {
      mm: "14 x 12",
      weight: "11.26",
    },
    {
      mm: "16 x 12",
      weight: "14.22",
    },
  ],
};
